var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-nav',{staticClass:"hero-nav d-inline-flex"},_vm._l((_vm.heroNavTabs),function(tab){return _c('NavTab',{key:tab.title,attrs:{"href":tab.path,"label":_vm.$t(tab.title),"special-class":_vm.contentType,"locked":tab.locked},on:{"click-attempt":function($event){return _vm.handleClickAttempt(tab.locked)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }